import { useFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/form/use-form-validation';
import { LOGIN_OTP_LENGTH } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/patterns';
import { useMemo } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type EmailOtpForm = {
  emailAddress: string;
  code: string;
};

export function useEmailOtpFormValidation(): {
  emailAddress: RegisterOptions<EmailOtpForm, 'emailAddress'>;
  code: RegisterOptions<EmailOtpForm, 'code'>;
} {
  const { t } = useTranslation();

  const formValidationRules = useFormValidation();

  return useMemo(
    () => ({
      emailAddress: {
        ...formValidationRules.required({
          field: t('verify-otp.emailAddress'),
        }),
        ...formValidationRules.emailPattern({
          field: t('verify-otp.emailAddress'),
        }),
      },
      code: {
        ...formValidationRules.required({
          field: t('verify-otp.code'),
        }),
        ...formValidationRules.length({
          field: t('verify-otp.code'),
          value: LOGIN_OTP_LENGTH,
        }),
        ...formValidationRules.otpPattern({
          field: t('verify-otp.code'),
        }),
      },
    }),
    [formValidationRules, t],
  );
}
